import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CtaPopup } from '../../../infra/ui/cta-popup';
import styles from './styles.module.scss';
import { RoleAwareLink } from '../../../infra/ui/role-aware-link';
import Icon, { GLYPHS } from '../../../../app/common/icon';
export var EngageCtaPopup = function (_a) {
    var onClose = _a.onClose;
    return (_jsx(CtaPopup, { id: "engage", showCloseButton: true, onClose: onClose, children: _jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.heading, children: "Fill-up your schedule by engaging with your\u00A0clients." }), _jsxs(RoleAwareLink, { className: styles.link, to: "/engagement", onClick: onClose, children: ["Let's Start\u00A0", _jsx(Icon, { glyph: GLYPHS.chevronLeftBold })] }), _jsx("div", { className: styles.image })] }) }));
};
